export function checkUserRoles(role, against, options = {}) {
    if (!role)
        return false;
    const userRoles = typeof role === 'function' ? role() : role;
    const convertedAgainstRolesRaw = Array.isArray(against) ? against : [against];
    const convertedUserRolesRaw = Array.isArray(userRoles)
        ? userRoles
        : [userRoles];
    const convertedAgainstRoles = options.lowercase
        ? convertedAgainstRolesRaw.map(r => r.toLowerCase())
        : convertedAgainstRolesRaw;
    const convertedUserRoles = options.lowercase
        ? convertedUserRolesRaw.map(r => r.toLowerCase())
        : convertedUserRolesRaw;
    if (convertedAgainstRoles.length === 0)
        return !!options.all;
    if (options.all)
        return convertedAgainstRoles.every(r => convertedUserRoles.includes(r));
    return convertedAgainstRoles.some(r => convertedUserRoles.includes(r));
}
//# sourceMappingURL=checkUserRoles.js.map